import styles from "./style.module.scss";
import { FormData } from "src/types/form";

const OPTIONS = {
  YAKISOBA: "買い物から調理まで！元祖石巻焼そばづくり",
  FISHING: "釣り船に乗って旬の魚をフィッシング釣り体験",
  DIVING: "ダイビングで四季のある海の中へ",
  SAUNA: "自然の循環を感じ、森に溶け込む極上サウナ",
};

const ROOM_TYPES = {
  SANRIKU: "SANRIKU",
  JIGNOMAKI: "JIGNOMAKI",
};

export const ConfirmSection = ({
  formData,
  onConfirm,
  setIsShowConfirm,
}: {
  formData: FormData;
  onConfirm: () => void;
  setIsShowConfirm: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h3>確認画面</h3>

        <ul>
          <li>
            <p className={styles.label}>日程</p>
            <p>
              {formData.startDate} ~ {formData.endDate}
            </p>
          </li>
          <li>
            <p className={styles.label}>利用人数</p>
            <p>
              大人{formData.adultCount}名 子供{formData.childCount}名
            </p>
          </li>
          <li>
            <p className={styles.label}>部屋タイプ</p>
            <p>
              {formData.roomType && ROOM_TYPES[formData.roomType as keyof typeof ROOM_TYPES]}
            </p>
          </li>
          <li>
            <p className={styles.label}>お名前</p>
            <p>{formData.name}</p>
          </li>
          <li>
            <p className={styles.label}>ふりがな</p>
            <p>{formData.kanaName}</p>
          </li>
          <li>
            <p className={styles.label}>電話番号</p>
            <p>{formData.phone}</p>
          </li>
          <li>
            <p className={styles.label}>メールアドレス</p>
            <p>{formData.email}</p>
          </li>
          <li>
            <p className={styles.label}>メールアドレス(再入力)</p>
            <p>{formData.emailConfirm}</p>
          </li>
          <li>
            <p className={styles.label}>郵便番号</p>
            <p>{formData.postalCode}</p>
          </li>
          <li>
            <p className={styles.label}>都道府県</p>
            <p>{formData.prefecture}</p>
          </li>
          <li>
            <p className={styles.label}>市区町村郡／番地</p>
            <p>{formData.city}</p>
          </li>
          <li className={styles.optionsBox}>
            <p className={styles.label}>体験希望</p>
            <div className={styles.options}>
              {formData.options && formData.options.length > 0
                ? formData.options
                    .filter(
                      (option): option is keyof typeof OPTIONS => option !== ""
                    )
                    .map((option) => <p key={option}>・{OPTIONS[option]}</p>)
                : "なし"}
            </div>
          </li>
          <li className={styles.optionsBox}>
            <p className={styles.label}>その他の要望（任意）</p>
            <div className={styles.body}>{formData.body}</div>
          </li>
        </ul>

        <div className={styles.submitBox}>
          <button onClick={onConfirm}>予約する</button>
          <button
            onClick={() => setIsShowConfirm(false)}
            className={styles.outline}
          >
            戻る
          </button>
        </div>
      </div>
    </section>
  );
};
